<div class="card">
  <div class="card-body up">
    <div class="cont_info">
      <div class="info" *ngIf="modelRemuneration && showRemuneration">
        <img src="../../../assets/images/amazon-giftcard.svg" class="logo-card" alt="Tarjeta Regalo Amazon">
      </div>
      <h5 [ngClass]="{'mt-3': modelRemuneration && showRemuneration}" class="title-card mt-3">{{model.Title}}</h5>
      <div class="info-text range-date"><strong>Desde</strong> {{model.StartDate | date:'dd-MM-yyyy'}} / <strong>Hasta</strong>
        {{model.EndDate | date:'dd-MM-yyyy'}}</div>
    </div>

    <div class="logo">
      <img src="../../../assets/images/amazon-simplylogo.svg" class="amazon-simply" alt="Amazon">
    </div>
  </div>

  <div class="card-body" *ngIf="showRemuneration && modelRemuneration">
    <div class="cont_amount">
      <div class="info-text">Saldo Actual</div>
      <div class="total-amount">{{modelRemuneration.TotalRemuneration | currency:'EUR'}}</div>
    </div>
  </div>

  <div class="card-footer">
    <img src="../../../assets/images/rg-logo-white.svg" class="logo-rg" alt="Renault Group">
    <div class="info-text" *ngIf="model.IsOpen"><strong>Estado:</strong> En curso</div>
    <div class="info-text" *ngIf="!model.IsOpen"><strong>Estado:</strong> Finalizado</div>
  </div>
</div>